import { msg } from "@omegagrid/localize";
import { NodeModel, NodeSource, TreeSource } from "@omegagrid/tree";
import rp, { BrowserAdapter, BrowserMenuItem, BrowserOptions } from "@reporting/rp-app-host";
import { Page } from '@reporting/rp-types/wiki';
import { copyWikiPageLink, pageComponentId } from "../helpers";

/** The reading tree of a wiki: its visible pages, in folders by their names. */
export class PageBrowserAdapter extends BrowserAdapter {

	constructor(private a: number = 0) { super() }

	async getTree(): Promise<TreeSource> {
		const pages = await rp.ms('wiki').get<Page[]>(`pages/visible`, {
			accounting: this.a,
			lang: rp.userProvider?.user?.lang,
		});
		if(!pages) return null;
		// sort by name so that items of the same folder are adjacent (flat tree relies on order + level)
		pages.sort((a, b) => {
			if(a.name < b.name) return -1;
			if(a.name > b.name) return 1;
			return 0;
		});
		const createdFolders = new Set<string>();
		const folderItems: NodeSource[] = [];
		const items: NodeSource[] = [];
		pages.forEach(page => {
			let nodeLvl = 0;
			let pageName = page.name;
			const nameParts = page.name.split('/');
			if(nameParts.length > 1) {
				pageName = nameParts.pop();
				nameParts.forEach((folderName, index) => {
					const path = nameParts.slice(0, index + 1).join('/');
					if(!createdFolders.has(path)) {
						createdFolders.add(path);
						folderItems.push({
							k: path,
							v: folderName,
							l: index,
							collapsed: true,
							folder: BrowserAdapter.folderOptions
						});
					}
					nodeLvl++;
				});
			}

			const newItem: NodeSource = {
				k: pageComponentId(this.a, page.id_wiki_page),
				v: pageName,
				l: nodeLvl,
				icon: { icon: 'file-lines' },
				props: { page }
			};
			if (nodeLvl == 0) items.push(newItem);
			else folderItems.push(newItem);
		});
		return [...items, ...folderItems];
	}

	/** A page offers its address (the one the IDE copies as well); folders have no menu. */
	getMenuItems(node: NodeModel): BrowserMenuItem[] {
		if (node.folder || !node.properties?.page) return null;
		return [{ key: 'copyLink', value: msg('Copy link'), icon: 'link' }];
	}

	async onAction(key: string, node: NodeModel) {
		const page = node.properties?.page as Page;
		if (key === 'copyLink' && page?.name) await copyWikiPageLink(this.a, page.name);
	}

	getOptions(): Partial<BrowserOptions> {
		return this.createOptions({
			selectMode: 'none',
			expanders: false,
			search: false,
			afterRenderer: null,
		});
	}

}
